export const getSupportedFormatsWithParentheses = (accept: string[] | undefined) => {
	return (accept ?? []).reduce((accumulator, mimeType) => {
		const extension = mimeType.split('/')?.[1];
		if (extension) {
			const extensionString = `${extension.toUpperCase()} (.${extension})`;
			return `${accumulator}${!accumulator ? extensionString : `, .${extensionString}`}`;
		}

		return accumulator;
	}, '');
};
